module.exports = __webpack_public_path__ + "static/create-account-25ff3cce40587b2f8e0018db1970d5c0.png";